import React, { useRef, useState } from "react";
import { Text, View } from "react-native";
import { fetchApi } from "../api";
import { STYLES } from "../assets/styles";
import Logo from "../common/Logo";
import CustomButton from "./CustomButton";
import CustomIcon from "./CustomIcon";
import CustomInput from "./CustomInput";
import OneTimeCode from "./OneTimeCode";

function Forgot({
  onLoadingChange = () => {},
  onSuccess = () => {},
  color = "#000000",
  containerStyle = {},
  transparent,
  close = false,
  onClose = () => {},
}) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [cpPassword, setCpPassword] = useState("");
  const [error, setError] = useState(null);
  const [verified, setVerified] = useState(false);
  const userCode = useRef(null);

  const requestCode = () => {
    onLoadingChange(true);
    fetchApi({ path: `/forgot/${email}` }).then((res) => {
      if (!res.error) {
        userCode.current = res;
        setError(null);
      } else {
        setError(res.error_description);
      }
      onLoadingChange(false);
    });
  };

  const updatePassword = () => {
    if (password === cpPassword) {
      onLoadingChange(true);
      fetchApi({
        path: `/forgot/${userCode.current._id}`,
        method: "POST",
        body: {
          password,
        },
      }).then((res) => {
        if (!res.error) {
          onSuccess();
        } else {
          setError(res.error_description);
        }
        onLoadingChange(false);
      });
    } else {
      setError("Passwords not matched");
    }
  };

  const handleCodeCheck = (error, success) => {
    if (error) {
      setError(error.error);
    } else {
      setVerified(true);
      setError(null);
    }
  };

  return (
    <View
      style={[
        transparent ? {} : STYLES.shadow,
        {
          width: "90%",
          padding: 20,
        },
        containerStyle,
      ]}
    >
      <View style={{ flexDirection: "row", justifyContent: "space-between" }}>
        <Logo color={color} />
        {close && !verified ? (
          <CustomIcon type="AntDesign" name="close" onPress={onClose} />
        ) : null}
      </View>
      <Text
        style={{
          color: color,
          fontSize: STYLES.fontSizes.xlarge,
          marginVertical: 15,
        }}
      >
        {verified ? "Update Password" : "Forget Password ?"}
      </Text>
      {verified ? (
        <View style={{ padding: 20, borderRadius: 10 }}>
          <CustomInput
            value={password}
            onChangeText={setPassword}
            leftIcon={{ type: "MaterialIcons", name: "lock" }}
            required
            requiredText="password must contain symbol, number ,uppercase , lowercase and length 8"
            color="#000000"
            transparent
            placeholder="Password"
          />
          <CustomInput
            value={cpPassword}
            onChangeText={setCpPassword}
            leftIcon={{ type: "MaterialIcons", name: "lock" }}
            transparent
            color="#000000"
            placeholder="Current Password"
            required
            requiredText="must be same as the above input value"
          />
          {error ? (
            <Text
              style={{
                fontWeight: "bold",
                textAlign: "center",
                color: STYLES.colors.tomato,
                marginTop: 10,
                fontSize: STYLES.fontSizes.small,
              }}
            >
              {error}
            </Text>
          ) : null}
          <CustomButton
            onPress={updatePassword}
            disabled={!password || !cpPassword}
            text="Submit"
            transparent
            btnStyle={{
              marginVertical: 20,
              width: "90%",
              alignSelf: "center",
              backgroundColor:
                !password || !cpPassword ? "grey" : STYLES.colors.black,
            }}
            textStyle={{
              color: STYLES.colors.white,
            }}
          />
        </View>
      ) : (
        <View>
          <Text
            style={{
              color: STYLES.colors.black,
              fontSize: STYLES.fontSizes.small,
            }}
          >
            {
              "If you forget your account password please\nenter your Registered Email address"
            }
          </Text>
          {userCode.current ? (
            <Text
              style={{
                color: "grey",
                fontSize: STYLES.fontSizes.small,
              }}
            >
              {"OTP has sent to your Email address"}
            </Text>
          ) : null}
          <View
            style={{
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              padding: 20,
            }}
          >
            <CustomInput
              leftIcon={{
                type: "MaterialCommunityIcons",
                name: "email-newsletter",
              }}
              value={email}
              onChangeText={setEmail}
              color={STYLES.colors.black}
              transparent
              placeholder="Enter Registered Email"
            />
            {error ? (
              <Text
                style={{
                  fontWeight: "bold",
                  color: STYLES.colors.tomato,
                  marginTop: 10,
                  fontSize: STYLES.fontSizes.small,
                }}
              >
                {error}
              </Text>
            ) : null}
            <Text style={{ fontWeight: "bold", marginTop: 10 }}>Enter OTP</Text>
            <OneTimeCode
              checkCode={userCode.current && userCode.current.code}
              disabled={!userCode.current}
              onFill={handleCodeCheck}
            />
            <CustomButton
              onPress={requestCode}
              disabled={!email || userCode.current}
              text="Send"
              transparent
              btnStyle={{
                marginVertical: 20,
                width: "90%",
                backgroundColor:
                  !email || userCode.current ? "grey" : STYLES.colors.black,
              }}
              textStyle={{
                color: STYLES.colors.white,
              }}
            />
          </View>
        </View>
      )}
    </View>
  );
}

export default Forgot;
